function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */ import { Popover } from 'antd';
import moment from 'moment';
import { PureComponent } from 'react';
import { queueMacrotask } from 'utils/macrotask';
import { uid } from 'utils/uid';
import { DueDateRangePicker } from './range-picker';
import { DueDateSinglePicker } from './single-picker';
import { DueDatePickerTrigger } from './trigger';
const DATE_FORMAT = 'DD/MM/YYYY';
/**
 * @deprecated use custom-due-date-picker which handles date in API_DATE_FORMAT
 */ export class DueDatePicker extends PureComponent {
    componentDidUpdate(_, { datePickerVisibility }) {
        if (!datePickerVisibility) {
            const { startDate } = this.state;
            const { isRangePicker } = this.props;
            this.setPicker(isRangePicker || !!startDate);
        }
    }
    setPicker(isRangePicker) {
        this.popoverRefId = isRangePicker ? this.rangePopoverRefId : this.singlePopoverRefId;
        this.setState({
            isRangePicker
        });
    }
    focusInsideFirstInputField() {
        queueMacrotask(()=>{
            const $input = document.querySelector(`#${this.popoverRefId} .ant-picker-input input`);
            if ($input) {
                $input.focus();
            }
        });
    }
    updateDate(values) {
        const { onDateChange } = this.props;
        if (values == null) {
            this.setState({
                startDate: null,
                dueDate: null
            });
            if (onDateChange) {
                onDateChange([
                    null,
                    null
                ]);
            }
            return;
        }
        const [updatedStartDate, updatedDueDate] = values;
        this.setState({
            startDate: updatedStartDate,
            dueDate: updatedDueDate
        });
        if (onDateChange) {
            onDateChange([
                (updatedStartDate === null || updatedStartDate === void 0 ? void 0 : updatedStartDate.valueOf()) || null,
                (updatedDueDate === null || updatedDueDate === void 0 ? void 0 : updatedDueDate.valueOf()) || null
            ]);
        }
    }
    updateDueDate(date) {
        this.updateDate([
            null,
            date
        ]);
        this.toggleDatePickerVisibility(false);
    }
    clearDates() {
        this.updateDate([
            null,
            null
        ]);
    }
    modifyPickerType() {
        const { isRangePicker } = this.state;
        this.setPicker(!isRangePicker);
        this.focusInsideFirstInputField();
    }
    pickToday() {
        this.setState({
            isRangePicker: false
        });
        this.updateDueDate(moment().endOf('day'));
    }
    pickTomorrow() {
        this.setState({
            isRangePicker: false
        });
        this.updateDueDate(moment().clone().add(1, 'day').endOf('day'));
    }
    toggleDatePickerVisibility(visibility) {
        const { onDatePickerVisibilityChange } = this.props;
        if (onDatePickerVisibilityChange) {
            onDatePickerVisibilityChange(visibility);
        }
        this.setState({
            datePickerVisibility: visibility
        });
    }
    showDatePicker() {
        this.toggleDatePickerVisibility(true);
        this.focusInsideFirstInputField();
    }
    closeDatePicker() {
        this.toggleDatePickerVisibility(false);
    }
    popupContainer() {
        return document.getElementById(this.popoverRefId);
    }
    render() {
        const { datePickerVisibility, isRangePicker, startDate, dueDate } = this.state;
        const { canChooseStartDate = true, hideFooter, className, renderTrigger, block, disabled, id, placeholder, overlayClassName, size = 'middle' } = this.props;
        const { clearDates, pickToday, pickTomorrow, modifyPickerType, showDatePicker, toggleDatePickerVisibility, updateDate, updateDueDate, popupContainer, closeDatePicker } = this;
        const hasValue = startDate || dueDate;
        return /*#__PURE__*/ _jsx(Popover, {
            id: this.popoverRefId,
            content: isRangePicker ? /*#__PURE__*/ _jsx(DueDateRangePicker, {
                canChooseStartDate: canChooseStartDate,
                getPopupContainer: popupContainer,
                format: DATE_FORMAT,
                value: [
                    startDate,
                    dueDate
                ],
                updateDateRange: updateDate,
                clearDates: clearDates,
                pickToday: pickToday,
                hideFooter: hideFooter,
                pickTomorrow: pickTomorrow,
                modifyPickerType: modifyPickerType,
                onDone: closeDatePicker
            }) : /*#__PURE__*/ _jsx(DueDateSinglePicker, {
                canChooseStartDate: canChooseStartDate,
                getPopupContainer: popupContainer,
                value: dueDate,
                format: DATE_FORMAT,
                updateDates: updateDueDate,
                clearDates: clearDates,
                pickToday: pickToday,
                hideFooter: hideFooter,
                pickTomorrow: pickTomorrow,
                modifyPickerType: modifyPickerType,
                onDone: closeDatePicker
            }),
            placement: "bottomLeft",
            trigger: "click",
            open: datePickerVisibility,
            onOpenChange: toggleDatePickerVisibility,
            overlayClassName: `due__date__picker ${overlayClassName || ''}`,
            children: renderTrigger ? renderTrigger(showDatePicker) : /*#__PURE__*/ _jsx(DueDatePickerTrigger, {
                className: className,
                block: block,
                disabled: disabled,
                hasValue: !!hasValue,
                id: id,
                placeholder: placeholder,
                size: size,
                startDate: startDate,
                dueDate: dueDate,
                onClick: showDatePicker
            })
        });
    }
    constructor(props){
        super(props), _define_property(this, "singlePopoverRefId", void 0), _define_property(this, "rangePopoverRefId", void 0), _define_property(this, "popoverRefId", '');
        this.rangePopoverRefId = uid('due-date-picker-range');
        this.singlePopoverRefId = uid('due-date-picker-single');
        const { startDate, dueDate, initialVisibile, isRangePicker: isRangePickerProps } = props;
        const isRangePicker = isRangePickerProps || !!startDate;
        this.state = {
            datePickerVisibility: !!initialVisibile,
            startDate: startDate ? moment(startDate) : null,
            dueDate: dueDate ? moment(dueDate) : null,
            isRangePicker
        };
        this.updateDate = this.updateDate.bind(this);
        this.updateDueDate = this.updateDueDate.bind(this);
        this.clearDates = this.clearDates.bind(this);
        this.modifyPickerType = this.modifyPickerType.bind(this);
        this.pickToday = this.pickToday.bind(this);
        this.pickTomorrow = this.pickTomorrow.bind(this);
        this.closeDatePicker = this.closeDatePicker.bind(this);
        this.toggleDatePickerVisibility = this.toggleDatePickerVisibility.bind(this);
        this.showDatePicker = this.showDatePicker.bind(this);
        this.popupContainer = this.popupContainer.bind(this);
        this.focusInsideFirstInputField = this.focusInsideFirstInputField.bind(this);
        this.setPicker = this.setPicker.bind(this);
        this.setPicker(isRangePicker);
    }
}
